import React, { ReactElement } from 'react';
import { Global, css } from '@emotion/core';
import avenirBlack from './fonts/Avenir-Black.ttf';
import avenirHeavy from './fonts/Avenir-Heavy.ttf';
import avenirLight from './fonts/Avenir-Light.ttf';

export const MarketingPageGlobalStyling = (): ReactElement => (
  <Global
    styles={css`
      @font-face {
        font-family: 'Avenir';
        font-style: normal;
        font-weight: 900;
        src: local('Avenir Black'), url(${avenirBlack}) format('truetype');
      }

      @font-face {
        font-family: 'Avenir';
        font-style: normal;
        font-weight: 800;
        src: local('Avenir Heavy'), url(${avenirHeavy}) format('truetype');
      }

      @font-face {
        font-family: 'Avenir';
        font-style: normal;
        font-weight: normal;
        src: local('Avenir'), url(${avenirLight}) format('truetype');
      }

      body {
        margin: 0;
        font-family: 'Avenir', sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
      }

      ::-moz-selection {
        background: rgba(5, 137, 150, 0.3);
      }
      ::selection {
        background: rgba(5, 137, 150, 0.3);
      }

      a,
      a:hover,
      a:visited,
      a:active,
      a:focus {
        text-decoration: none;
      }
    `}
  />
);
